import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import Swiper from "swiper";
import { Mousewheel, Pagination } from "swiper/modules";

const massimo = () => {

  document.addEventListener("DOMContentLoaded", () => {
    const hash = window.location.hash;
  
    if (hash) {
      setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });
        }
      }, 500); // ritardo di 500ms
    }
  });

  $(() => {




    $('.colonna_titolo').on('click', function() {

      if($(this).hasClass('first_col') && $(this).hasClass('active')) {
        console.log('qui')
        $('.colonna_img').removeClass('active')
        $('.colonna_titolo').removeClass('active')
        $(this).prev('.colonna_img').addClass('active')
      } else {
        $('.colonna_img').removeClass('active')
        $('.colonna_titolo').removeClass('active')
        $(this).addClass('active')
        $(this).next('.colonna_img').addClass('active')  
      }
    })
    
    if(window.innerWidth < 990) {
      $('.titolo-widget-sidebar').click(function() {
        $(this).toggleClass('open');
        $(this).next('div').toggle();
        if($(this).hasClass('open')) 
          $(this).find('.sub_toggler').html('-')
        else
          $(this).find('.sub_toggler').html('+')

        $(this).next('.widget-content').toggleClass('d-none');
      })
    }

    $('.open_submenu').click(function() {
      $('.open_submenu').not(this).removeClass('open');
      $('.open_submenu').not(this).html('+');
      $('.open_submenu').not(this).next('.dropdown_m').addClass('d-none');

      $(this).toggleClass('open');
      if($(this).hasClass('open')) 
        $(this).html('-')
      else
        $(this).html('+')

      $(this).next('.dropdown_m').toggleClass('d-none');
    })

    $('.arrow_container').click(function() {
      var nextSection = $(this).closest('section').next('section').offset().top
      $("html, body").animate({scrollTop: nextSection }, 500);
    })

    const tlMenuOpen = gsap.timeline({paused: true, reversed: true});
    tlMenuOpen

    
      .to(
        $('.overlay_menu'),
          { opacity: 1, visibility: 'visible', duration: .3}, 'overlay'
      )
      .to(
        $('.menu_wrapper .immagine_menu'),
          { y: 0, duration: .8, ease: "power2.in" }, 'animlogo'
      )
      .to(
        $('.menu_wrapper .immagine_menu img'),
          { y: 0, duration: .8, ease: "power2.in" }, 'animlogo'
      )
      .to(
        $('.main_menu_wrapper'),
          { y: 0, duration: .8, ease: "power2.in" }, 'animlogo'
      )
      .to(
        $('#menu-main-menu .menu-item'),
          { y: 0, opacity: 1, duration: .8, stagger: 0.06, delay:.5 }, 'animlogo'
      )
      .to(
        $('#menu-top-menu .menu-item'),
          { y: 0, opacity: 1, duration: .8, stagger: 0.06, delay:1 }, 'animlogo'
      )
      .to(
        $('.indirizzo_menu_wrapper'),
          { x: 0, duration: .8, ease: "power2.in" }, 'animlogo'
      )
      .to(
        $('.indirizzo_menu'),
          { x: 0, duration: .8, ease: "power2.in" }, 'animlogo'
      )
      
    $('.navbar-toggler').click(function() {
      if (tlMenuOpen.reversed()) {
        $('.navbar-toggler').removeClass('collapsed');
        tlMenuOpen.play();
      } else {
        $('.navbar-toggler').addClass('collapsed');
        tlMenuOpen.reverse();
      }
    });

    $('.dropdown_m .nav-link').on('click', function() {
      const href = $(this).attr("href");
      console.log(href)
      if (href && href.includes("#")) {
        
        const url = new URL(href, window.location.origin);
        const hash = url.hash; // es. "#fav"
        
        if (hash) {
          $('.navbar-toggler').addClass('collapsed');
          tlMenuOpen.reverse();
        }
      }
    })

    const tlHeaderOpen = gsap.timeline({paused: true});
    tlHeaderOpen
      .add(()=> {
          $('.header_pagine').addClass('aperto');
      })
      .fromTo(
        $('.header_pagine .img_background'),
          { x: -70 },
          { x: 0, duration: 1.5, delay: 0.5, ease: "cubic-bezier(0.16, 1, 0.3, 1) 0s" }
      )
      .fromTo(
        $('#logo_desktop'),
          { y: -10, opacity: 0 },
          { y: 0, opacity: 1, duration: .5, ease: "power2.out" },
          'animlogo'
      )
      .to(
        $('.header_pagine .titolo_pb'),
          { y: 0, opacity: 1, duration: 1.2, filter: "blur(0px)", ease: "power2.out" },
          'animlogo'
      )
    tlHeaderOpen.play();

    gsap.to('.header_pagine .wp-block-evidenzio-column', {
      y: 120,
      filter: "blur(10px)",
      scrollTrigger: {
        trigger: '.header_pagine',
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });


    if($('.wp-block-image.animazione').length) {
      const items = document.querySelectorAll(".wp-block-image.animazione");
      items.forEach((item) => {
    
        gsap.to(
          item,
          {
            opacity: 1,
            y: 0,
            duration: 2,
            ease: "expo.out",
            scrollTrigger: {
              trigger: item,
              start: "top bottom",
              toggleActions: "play none none none",
            },
          }
        )
        gsap.to(
          $(item).find('img'),
          {
            opacity: 1,
            y: 0,
            duration: 2,
            ease: "expo.out",
            scrollTrigger: {
              trigger: item,
              start: "top bottom",
              toggleActions: "play none none none",
            },
          }
        )
      })
        
    }
    


    if($('.team').length) {
      const rows = document.querySelectorAll(".team");
      rows.forEach((grid) => {
        const boxes = Array.from(grid.querySelectorAll(".wrapper2")); 
    
        // Raggruppa gli elementi per riga (3 per riga)
        const groupedRows = [];
        while (boxes.length) {
          groupedRows.push(boxes.splice(0, 4)); // Prende 3 elementi alla volta
        }
    
        groupedRows.forEach((row, index) => {
          gsap.to(
            row,
            {
              opacity: 1,
              y: 0,
              aspectRatio: 1,
              duration: 1,
              stagger: 0.15,
              ease: "expo.out",
              scrollTrigger: {
                trigger: row[0], // Usa il primo elemento della riga come trigger
                start: "top bottom", // Quando il primo div della riga entra nello schermo
                toggleActions: "play none none none",
              },
            }
          );
          row.forEach((box) => {
            gsap.to(box.querySelectorAll("img"), {
              opacity: 1,
              y: 0,
              duration: 3,
              stagger: 0.15,
              ease: "expo.out",
              scrollTrigger: {
                trigger: box, // Usa il singolo box come trigger
                start: "top bottom",
                toggleActions: "play none none none",
              },
            });
          });
        });
        
      });
    }

    gsap.to('#custom_html-2 .textwidget', {
      y: 0,
      filter: "blur(0px)",
      duration: 1,
      scrollTrigger: {
        trigger: '#footer',
        start: "top bottom",
        end: "bottom bottom",
        toggleActions: "play none none none",
      },
    });


    const textElement = document.querySelectorAll("#custom_html-2 .textwidget");
    gsap.from(textElement, {
      opacity: 0,
      y: 50,
      duration: 4,
      stagger: 0.3, // Simula uno stagger tra le righe
      ease: "expo.out",
    });

    if ($('.blocco_fasi').length && window.innerWidth > 990) {

      if($('.blocco_fasi').length && $('.swiper_fasi').data('initial-slide')) {
          var initialSlide = parseInt($('.swiper_fasi').data('initial-slide'));
      } else {
          var initialSlide = 0;
      }

      var slider_fasi = new Swiper(".swiper_fasi", {
        modules: [Pagination, Mousewheel],
        initialSlide: initialSlide,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            990: {
                allowTouchMove: false,
                direction: "vertical",
                mousewheel: false
            }
        }
      });



      let currentSlide = $('.swiper_fasi').data('initial-slide') || 0;
      const totalSlides = slider_fasi.slides.length;

      function updateActiveFase(index) {
        $('.blocco_fasi .fase').removeClass('active');
        $('.blocco_fasi .fase[data-index="' + index + '"]').addClass('active');
      }
      updateActiveFase(currentSlide);

      let isInScrollZone = false;
      let scrollLocked = false;
      let swiperUnlocked = false;
      let unlockTimeout;

      function disablePageScroll() {
        document.body.style.overflow = 'hidden';
        $('.hamburger').css('right', 'calc(4vw + 15px)')
      }

      function enablePageScroll() {
        document.body.style.overflow = '';
        $('.hamburger').css('right', '4vw')
      }

      ScrollTrigger.create({
        trigger: '.blocco_fasi',
        start: 'top top',
        end: () => `+=${window.innerHeight}`,
        pin: true,
        scrub: false,
        onEnter: () => {
          isInScrollZone = true;
          swiperUnlocked = false;
          disablePageScroll();
          unlockTimeout = setTimeout(() => {
            swiperUnlocked = true;
          }, 800); // ritardo sblocco (puoi regolare)
        },
        onLeave: () => {
          isInScrollZone = false;
          enablePageScroll();
          clearTimeout(unlockTimeout);
        },
        onEnterBack: () => {
          isInScrollZone = true;
          swiperUnlocked = false;
          disablePageScroll();
          unlockTimeout = setTimeout(() => {
            swiperUnlocked = true;
          }, 800); // stesso ritardo anche da sotto
        },
        onLeaveBack: () => {
          isInScrollZone = false;
          enablePageScroll();
          clearTimeout(unlockTimeout);
        },
      });

      const TESTO_SCROLL_STEP = 150;

      function getCurrentTesto() {
        const slide = slider_fasi.slides[currentSlide];
        return slide ? slide.querySelector('.testo_fase .wrapper') : null;
      }

      window.addEventListener('wheel', (e) => {
        if (!isInScrollZone || scrollLocked) return;

        e.preventDefault();

        if (!swiperUnlocked) {
          return;
        }

        const delta = e.deltaY;
        const testo = getCurrentTesto();

        if (delta > 40) {
          // Se il testo ha ancora contenuto da scorrere verso il basso, scrolla il testo
          if (testo) {
            const remaining = testo.scrollHeight - testo.clientHeight - testo.scrollTop;
            if (remaining > 2) {
              testo.scrollBy({ top: TESTO_SCROLL_STEP, behavior: 'smooth' });
              return;
            }
          }

          scrollLocked = true;
          if (currentSlide < totalSlides - 1) {
            currentSlide++;
            slider_fasi.slideTo(currentSlide);
            updateActiveFase(currentSlide);
            // Riporta il testo della nuova slide in cima
            const newTesto = getCurrentTesto();
            if (newTesto) newTesto.scrollTop = 0;
            setTimeout(() => scrollLocked = false, 500);
          } else {
            isInScrollZone = false;
            enablePageScroll();
            ScrollTrigger.getAll().forEach(t => t.enable());
            scrollLocked = false;
          }
          setTimeout(() => scrollLocked = false, 1000);

        } else if (delta < -40) {
          // Se il testo ha ancora contenuto da scorrere verso l'alto, scrolla il testo
          if (testo && testo.scrollTop > 2) {
            testo.scrollBy({ top: -TESTO_SCROLL_STEP, behavior: 'smooth' });
            return;
          }

          scrollLocked = true;
          if (currentSlide > 0) {
            currentSlide--;
            slider_fasi.slideTo(currentSlide);
            updateActiveFase(currentSlide);
            // Posiziona il testo della slide precedente in fondo
            const prevTesto = getCurrentTesto();
            if (prevTesto) {
              setTimeout(() => { prevTesto.scrollTop = prevTesto.scrollHeight; }, 400);
            }
          } else {
            isInScrollZone = false;
            enablePageScroll();
            ScrollTrigger.getAll().forEach(t => t.enable());
            window.scrollBy(0, -50);
          }
          setTimeout(() => scrollLocked = false, 1000);
        }
      }, { passive: false });


    }

    // icona1 entra quando raggiunge l'80% della viewport
    if ($('#icona1').length) {
      gsap.fromTo('#icona1',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "expo.out",
          scrollTrigger: {
            trigger: '#icona1',
            start: "top 80%",
            toggleActions: "play reverse play reverse",
          }
        }
      );
    }
    if ($('#icona2').length) {
      gsap.fromTo('#icona2',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "expo.out",
          scrollTrigger: {
            trigger: '#icona2',
            start: "top 50%",
            toggleActions: "play reverse play reverse",
          }
        }
      );
    }
    if ($('#icona3').length) {
      gsap.fromTo('#icona3',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "expo.out",
          scrollTrigger: {
            trigger: '#icona3',
            start: "top 55%",
            toggleActions: "play reverse play reverse",
          }
        }
      );
    }
    // linea1 si disegna allo scroll
    if ($('#linea1').length) {
      const pathEl = document.querySelector('#linea1 path');
      if (pathEl) {
        const pathLength = pathEl.getTotalLength();
        gsap.set(pathEl, {
          strokeDasharray: pathLength,
          strokeDashoffset: -pathLength,
        });
        gsap.to(pathEl, {
          strokeDashoffset: 0,
          ease: "none",
          scrollTrigger: {
            trigger: '#linea1',
            start: "top 80%",
            end: "bottom 50%",
            scrub: 1,
          }
        });
      }
    }
    if ($('#linea2').length) {
      const pathEl = document.querySelector('#linea2 path');
      if (pathEl) {
        const pathLength = pathEl.getTotalLength();
        gsap.set(pathEl, {
          strokeDasharray: pathLength,
          strokeDashoffset: pathLength,
        });
        gsap.to(pathEl, {
          strokeDashoffset: 0,
          ease: "none",
          scrollTrigger: {
            trigger: '#linea2',
            start: "top 50%",
            end: "bottom 55%",
            scrub: 1,
          }
        });
      }
    }
    // split text manuale per testo_icona1/2/3
    ['#testo_icona1', '#testo_icona2', '#testo_icona3'].forEach((sel) => {
      const container = document.querySelector(sel);
      if (!container) return;

      container.querySelectorAll('p').forEach((p) => {
        const words = p.innerText.split(' ');
        p.innerHTML = words
          .map(w => `<span style="display:inline-block;overflow:hidden;vertical-align:bottom;"><span class="split-inner" style="display:inline-block;">${w}</span></span>`)
          .join(' ');
      });

      const img = container.querySelector('img');
      if (img) {
        gsap.fromTo(img,
          { opacity: 0, scale: 0.8, y: 20 },
          {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 0.7,
            ease: 'expo.out',
            scrollTrigger: {
              trigger: container,
              start: 'top 85%',
              toggleActions: 'play reverse play reverse',
            }
          }
        );
      }

      const inners = container.querySelectorAll('.split-inner');
      gsap.fromTo(inners,
        { y: '100%', opacity: 0 },
        {
          y: '0%',
          opacity: 1,
          duration: 0.6,
          ease: 'expo.out',
          stagger: 0.06,
          delay: 0.2,
          scrollTrigger: {
            trigger: container,
            start: 'top 85%',
            toggleActions: 'play reverse play reverse',
          }
        }
      );
    });

    let numeri = document.querySelectorAll(".numero");

    numeri.forEach(numero => {
        let valoreFinale = parseInt(numero.innerText.replace(/\D/g, ""), 10); // Rimuove i caratteri non numerici
        let prefisso = numero.innerText.replace(/\d/g, ""); // Es. "+" o "MIO"

        gsap.fromTo(numero,
            { innerText: 0 },
            {
                innerText: valoreFinale,
                duration: 2,
                scrollTrigger: {
                    trigger: numero,
                    start: "top 80%", // Quando il numero entra nel viewport
                    toggleActions: "play none none none",
                },
                snap: { innerText: 1 }, // Fa avanzare i numeri in interi
                onUpdate: function () {
                    numero.innerText = prefisso + Math.round(numero.innerText);
                }
            }
        );
    });

    // blocco_gruppo: le linee SVG si disegnano seguendo lo scroll
    document.querySelectorAll('.blocco_gruppo .linee').forEach((lineeContainer) => {
      const svgEls = lineeContainer.querySelectorAll('#linea_centrale line, #linea_sx path, #linea_dx path');
      if (!svgEls.length) return;

      svgEls.forEach((el) => {
        const length = el.getTotalLength();
        gsap.set(el, {
          strokeDasharray: length,
          strokeDashoffset: length,
        });
        gsap.to(el, {
          strokeDashoffset: 0,
          ease: "none",
          scrollTrigger: {
            trigger: lineeContainer,
            start: "top 80%",
            end: "bottom 50%",
            scrub: 1,
          }
        });
      });
    });

  });
};

export default massimo;
